import React from 'react'
import PricingCard from '../pricingCard/PricingCard'
import AnsweringServices from './AnsweringServices'
import DedicatedServices from './DedicatedServices'
import CaymanDedicatedServices from './CaymanDedicatedServices'

import './PricingCardList.scss'
const PricingCardList = ({ type }) => {
  let list
  if (type === 'answering') {
    list = AnsweringServices
  }
  if (type === 'dedicated') {
    list = DedicatedServices
  }
  if (type === 'cayman') {
    list = CaymanDedicatedServices
  }
  return (
    <div>
      {list.map((item, index) => {
        return <PricingCard key={index} data={item} />
      })}
    </div>
  )
}

export default PricingCardList
